var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiUserIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.108 6.385A3.959 3.959 0 0 1 6 7a3.959 3.959 0 0 1-2.108-.615 5.954 5.954 0 0 0-3.865 5.07.497.497 0 0 0 .498.545h10.95a.498.498 0 0 0 .498-.545 5.954 5.954 0 0 0-3.865-5.07ZM6 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
})));
export default SvgHaidiUserIcon;